import {ErrorHandler, Injectable} from '@angular/core';
import {Client} from '@bugsnag/js';
import {BAD_REQUEST_400, FORBIDDEN_403, NOT_VALID_422, UNAUTHORISED_401} from '../constants/statuses.constants';
import {CURRENT_USER_STORAGE_KEY} from '../constants/local-storage-keys.constansts';
import {CurrentUserDetailsModel} from '../../shared/models/users/users.models';

// Any is needed to keep Bugsnag running can't attach any correct interface
export declare class BugsnagInterface extends Client {
  // tslint:disable-next-line:variable-name
  _client: any;
}

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService extends ErrorHandler {

  public bugsnagClient: BugsnagInterface;

  /**
   * type any is used for client because bugsnag doesn't have proper interface
   */
  constructor(client?: any) {
    super();
    if (client) {
      this.bugsnagClient = client;
    }
  }

  public handleError(error: any): void {
    const serverIgnoreError = [UNAUTHORISED_401, FORBIDDEN_403, NOT_VALID_422, BAD_REQUEST_400].some((status) => status === error?.status);
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    const chunkFailedMessageError = chunkFailedMessage.test(error.message);

    console.error('Error on our side', error, serverIgnoreError);

    if (this.bugsnagClient
      && !serverIgnoreError && !chunkFailedMessageError) {
      this.notifyBugsnag(error);
    }

    if (chunkFailedMessageError) {
      window.location.reload();
    }

    if (!serverIgnoreError && !chunkFailedMessageError) {
      ErrorHandler.prototype.handleError.call(this, error);
    }

  }

  private notifyBugsnag(error): void {
    const handledState = {
      severity: 'error',
      severityReason: {type: 'unhandledException'},
      unhandled: true
    };
    const event = this.bugsnagClient.Event.create(
      error,
      true,
      handledState,
      'angular error handler',
      1
    );

    const userDetails = this.getUserDetails();

    if (userDetails) {
      event.addMetadata('user_details', {
        id: userDetails.id,
        name: userDetails.name,
        email: userDetails.email
      });
    }

    if (error.ngDebugContext) {
      event.addMetadata('angular', {
        component: error.ngDebugContext.component,
        context: error.ngDebugContext.context
      });
    }

    this.bugsnagClient._client._notify(event);
  }

  private getUserDetails(): CurrentUserDetailsModel | undefined {
    const details = localStorage.getItem(CURRENT_USER_STORAGE_KEY);
    if (details) {
      try {
        return JSON.parse(details);
      } catch (e) {
        return undefined;
      }
    }
    return undefined;
  }


}
